import Slider from 'components/Slider';
import { useStores } from 'hooks';
import React from 'react';
import useSWR from 'swr';

const PageWrap = ({ children, title, slug }) => {
  const { api } = useStores();

  const { data: recommendedProducts } = useSWR(
    { slug, _key: `ng-recommended-${slug}` },
    api.newCatalog.getRecommendedProducts
  );

  return (
    <main>
      <section className="calculator">
        <div className="calculator-wrap">
            <div style={{ marginBottom: '64px' }}>
              <Slider products={recommendedProducts} />
            </div>
          <h1 className="calculator-title">{title}</h1>
          {children}
        </div>
      </section>
    </main>
  );
};

export default PageWrap;
